import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-compass-3-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-bold text-white font-heading whitespace-nowrap">
                51网址导航
              </span>
            </Link>
            <p className="text-sm text-secondary-200 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">
              热门分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-200 hover:text-white transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">
              快捷入口
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link
                  to="/"
                  className="text-sm text-secondary-200 hover:text-white transition-colors cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/category/remenzixun"
                  className="text-sm text-secondary-200 hover:text-white transition-colors cursor-pointer"
                >
                  热门资讯
                </Link>
              </li>
              <li>
                <Link
                  to="/category/chigua"
                  className="text-sm text-secondary-200 hover:text-white transition-colors cursor-pointer"
                >
                  吃瓜事件
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-secondary-200 hover:text-white transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4 font-heading">
              联系我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li className="flex items-center gap-2 text-sm text-secondary-200">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.email}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-200">
                <i className="ri-phone-line"></i>
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-secondary-200">
                <i className="ri-map-pin-line"></i>
                <span>{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-300">
            <span>网址导航123</span>
            <span>|</span>
            <span>123导航</span>
            <span>|</span>
            <span>导航123</span>
            <span>|</span>
            <span>网址123</span>
          </div>
        </div>
      </div>
    </footer>
  );
}